import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const CHANGE_OF_REGISTERED_AGENT_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.changeOfRegisteredAgent.buyBox.bulletPoint1' },
        { title: 'productPage.changeOfRegisteredAgent.buyBox.bulletPoint2' },
        { title: 'productPage.changeOfRegisteredAgent.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.changeOfRegisteredAgent.buyBox.productName',
      note: 'productPage.changeOfRegisteredAgent.buyBox.subCopy',
      interactService: {
        service: 'change_of_registered_agent'
      }
    }],
    headerPicture: {
      src: '/s2/raster/reading-documents-home.png',
      alt: 'productPage.changeOfRegisteredAgent.heroPicture.altText'
    },
    headline: 'productPage.changeOfRegisteredAgent.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.changeOfRegisteredAgent.page.headlinePill',
      bgcolor: 'background.red.light'
    },
    subheader: 'productPage.changeOfRegisteredAgent.page.subheader'
  },
  benefit: {
    title: 'productPage.changeOfRegisteredAgent.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.changeOfRegisteredAgent.valueProp.propTitle1',
        description: 'productPage.changeOfRegisteredAgent.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/securityrounded.svg',
        title: 'productPage.changeOfRegisteredAgent.valueProp.propTitle2',
        description: 'productPage.changeOfRegisteredAgent.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/inboxrounded.svg',
        title: 'productPage.changeOfRegisteredAgent.valueProp.propTitle3',
        description: 'productPage.changeOfRegisteredAgent.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/locationonrounded.svg',
        title: 'productPage.changeOfRegisteredAgent.valueProp.propTitle4',
        description: 'productPage.changeOfRegisteredAgent.valueProp.shortCopy4'
      },
      {
        icon: '/s2/material-icons/strikethroughsrounded.svg',
        title: 'productPage.changeOfRegisteredAgent.valueProp.propTitle5',
        description: 'productPage.changeOfRegisteredAgent.valueProp.shortCopy5'
      },
      {
        icon: '/s2/material-icons/supportagentrounded.svg',
        title: 'productPage.changeOfRegisteredAgent.valueProp.propTitle6',
        description: 'productPage.changeOfRegisteredAgent.valueProp.shortCopy6'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/shieldrounded.svg',
    title: 'productPage.changeOfRegisteredAgent.topFeature.title',
    subheader: 'productPage.changeOfRegisteredAgent.topFeature.subheader',
    video: 'y8guj357t9',
    alt: 'productPage.changeOfRegisteredAgent.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.changeOfRegisteredAgent.howItWorks.title',
    items: [
      {
        title: 'productPage.changeOfRegisteredAgent.howItWorks.step1',
        description: 'productPage.changeOfRegisteredAgent.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.changeOfRegisteredAgent.howItWorks.step2',
        description: 'productPage.changeOfRegisteredAgent.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.changeOfRegisteredAgent.howItWorks.step3',
        description: 'productPage.changeOfRegisteredAgent.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/review-laptop-smiling.png',
    alt: 'productPage.changeOfRegisteredAgent.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faq1',
        answer: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faq2',
        answer: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faq3',
        answer: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faq4',
        answer: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faqAnswer4'
      },
      {
        question: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faq5',
        answer: 'productPage.changeOfRegisteredAgent.frequentlyAskedQuestions.faqAnswer5'
      }
    ]
  },
  assistance: {
    title: 'productPage.changeOfRegisteredAgent.needAssistance.title',
    getInTouch: 'productPage.changeOfRegisteredAgent.needAssistance.getInTouch',
    actions: 'productPage.changeOfRegisteredAgent.needAssistance.actions'
  },
  getBuyButtonConfig: (entitlements, service) => getBuyButtonConfig({
    entitlements,
    service,
    ctaText: 'productPage.changeOfRegisteredAgent.buyBox.buttonLabel'
  })
};
